import { SearchIcon } from "../../icons/search";
import React, { useEffect, useState } from "react";


const PanelSearch = (props: { hint: string; onChange: (value: string) => void}) => {
    const {hint, onChange} = props;
    const [serachValue, setSearchValue] = useState<string>("");

    const onChangeHandler = (event) => {
        const value = event.target?.value || ""
        setSearchValue(value);
        onChange(value);
    }

    return(
        <div className="searchPanel flex">
           <SearchIcon width={24} height={24} />
           <input className="panelSearchInput" type="text" placeholder={hint} onChange={onChangeHandler} />
        </div>
    )
}

export default PanelSearch;